export const STANDARD_LIBRARY_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png'];

export const RESOURCE_LIBRARY_EXTENSIONS = [
    ...STANDARD_LIBRARY_EXTENSIONS,
    'doc',
    'docx',
    'xls',
    'xlsx',
];

const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png']);

export function getLibraryUploadExtensions(documentType) {
    return documentType === 'RESOURCE'
        ? RESOURCE_LIBRARY_EXTENSIONS
        : STANDARD_LIBRARY_EXTENSIONS;
}

export function getLibraryFileAction(file = {}) {
    const fileType = String(file.file_type || '').toLowerCase();
    const extension = String(file.original_filename || '')
        .split('.')
        .pop()
        .toLowerCase();

    if (fileType === 'application/pdf' || extension === 'pdf') {
        return 'pdf';
    }

    if (fileType.startsWith('image/') || IMAGE_EXTENSIONS.has(extension)) {
        return 'preview';
    }

    return 'download';
}
